import { Grid, Paper, Tabs, Tab, FormControl, Select, MenuItem, Hidden } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { trackBlogClick } from './analytics'

const BlogItem = ({ blog }) => {
  const { title, createdAt, imagePath, link } = blog;
  
  const handleBlogClick = () => {
    // Track the blog click event
    trackBlogClick(title);
    
    // Open the blog post
    window.open(link, '_blank');
  };

  return (
    <Paper
      elevation={2}
      style={{
        height: '100%',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClick={handleBlogClick}
    >
      <div style={{
        width: '100%',
        paddingTop: '56.25%', /* 16:9 Aspect Ratio */
        position: 'relative',
        overflow: 'hidden'
      }}>
        <img
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          src={imagePath}
          alt={title}
        />
      </div>
      <div style={{ padding: '16px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '8px' }}>{title}</h3>
        <p style={{ margin: 0, color: '#666' }}>{createdAt}</p>
      </div>
    </Paper>
  )
}

export const BlogList = () => {
  const [blogItems, setBlogItems] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(0);

  // Define the categories
  const categories = ['ALL', 'React.js', 'Node.js', 'System Design', 'Others'];

  // Function to determine blog category based on title/content
  const getCategoryForBlog = (blog) => {
    const title = blog.title.toLowerCase();

    if (title.includes('react') || title.includes('frontend') || title.includes('jquery')) {
      return 'React.js';
    } else if (title.includes('node') || title.includes('express') || title.includes('javascript') || title.includes('redis')) {
      return 'Node.js';
    } else if (title.includes('aws') || title.includes('ci/cd') || title.includes('docker') || title.includes('streaming')) {
      return 'System Design';
    } else {
      return 'Others';
    }
  };

  // Filter blogs by category
  const filterBlogsByCategory = (categoryIndex) => {
    if (categoryIndex === 0) {
      // ALL category
      setFilteredBlogs(blogItems);
    } else {
      // Filter blogs by selected category
      const category = categories[categoryIndex];
      const filtered = blogItems.filter(blog => getCategoryForBlog(blog) === category);
      setFilteredBlogs(filtered);
    }
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setSelectedCategory(newValue);
    filterBlogsByCategory(newValue);
  };

  // Handle dropdown change
  const handleDropdownChange = (event) => {
    const newValue = event.target.value;
    setSelectedCategory(newValue);
    filterBlogsByCategory(newValue);
  };

  useEffect(() => {
    // Define the URL
    // const url = 'https://s3.ap-south-1.amazonaws.com/metadata.shams-nahid.com/blog-list.json';
    const url = '/blog-list.json';

    // Use fetch to get data from the URL
    fetch(url)
      .then(response => {
        // Check if the response is ok (status in the range 200-299)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        // Parse the JSON from the response
        return response.json();
      })
      .then(data => {
        // Handle the JSON data
        console.log(data);
        setBlogItems(data);
        setFilteredBlogs(data); // Initialize filtered blogs with all blogs
        // You can do further processing here
      })
      .catch(error => {
        // Handle errors
        console.error('There has been a problem with your fetch operation:', error);
      });

  }, []);

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto', paddingTop: '20px', paddingLeft: '16px', paddingRight: '16px' }}>

      {/* Tabs for larger screens */}
      {/* <Hidden smDown>
        <Paper style={{ marginBottom: '24px' }}>
          <Tabs
            value={selectedCategory}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
            variant="fullWidth"
          >
            {categories.map((category, index) => (
              <Tab key={index} label={category} />
            ))}
          </Tabs>
        </Paper>
      </Hidden> */}

      {/* Dropdown menu for smaller screens */}
      {/* <Hidden mdUp>
        <Paper style={{ marginBottom: '24px', padding: '10px' }}>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              value={selectedCategory}
              onChange={handleDropdownChange}
              displayEmpty
            >
              {categories.map((category, index) => (
                <MenuItem key={index} value={index}>{category}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Paper>
      </Hidden> */}

      <Grid container spacing={3}>
        {filteredBlogs.map((blog) => (
          <Grid key={blog.title} item xs={12} sm={6} md={4}>
            <BlogItem blog={blog} />
          </Grid>
        ))}
      </Grid>

      {/* Show message when no blogs in category */}
      {filteredBlogs.length === 0 && (
        <div style={{ textAlign: 'center', padding: '30px' }}>
          <p>No articles found in this category.</p>
        </div>
      )}
    </div>
  )
}